export default "__VITE_ASSET__DAAHKuby__"